import { EMPTY_STRING } from 'app/app.constants';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { List } from 'immutable';
import moment from 'moment';

export const Filters = {
  NAME: 'name',
  STATUS: 'status',
  FROM: 'from',
  TO: 'to',
};

export const ActivityTypes = {
  ACTIVITY: 1,
  PROJECT: 2,
};

export const ACTIVITY_TYPES = List([
  { id: 1, name: 'Activity' },
  { id: 2, name: 'Project' },
]);

const now = moment();
const sixMonthsAgo = now.clone().subtract(6, 'months');
const sixMonthsLater = now.clone().add(6, 'months');

export const InitialFormValues = {
  [Filters.NAME]: EMPTY_STRING,
  [Filters.STATUS]: [],
  [Filters.FROM]: sixMonthsAgo,
  [Filters.TO]: sixMonthsLater,
};

export const ACTIVITY_LOG_FORM_FEILDS = {
  ACTIVITY_LOG_ID: 'activityLogId',
  ACTIVITY_NAME: 'activityName',
  DESCRIPTION: 'description',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  STATUS: 'status',
  RESPONSIBLE: 'responsibleId',
  COMMENT: 'comment',
  MITIGATION_SOLUTIONS: 'mitigationSolutions',
};

export const ACTIVITY_LOG_FORM_FEILDS_LABELS = {
  ACTIVITY_NAME: 'Activity Name',
  DESCRIPTION: 'Description',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  STATUS: 'Status',
  RESPONSIBLE: 'Responsible',
  COMMENT: 'Comment',
  MITIGATION_SOLUTIONS: 'Solutions for mitigating challenges',
};

export const ACTIVITY_LOG_STATUSES = List([
  { id: 1, name: 'Scheduled' },
  { id: 2, name: 'In Progress' },
  { id: 3, name: 'Completed' },
  { id: 4, name: 'Pending' },
  { id: 5, name: 'Overdue' },
]);

export const ActivityLogStatus = {
  SCHEDULED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  PENDING: 4,
  OVERDUE: 5,
};

export const ACTIVITY_LOG_ACTIONS = {
  UPSERT_ACTIVITY_LOG: 'UPSERT_ACTIVITY_LOG',
  GET_INTEGRITY_MANAGEMENT_USERS_BY_ORGANIZATION:
    'GET_INTEGRITY_MANAGEMENT_USERS_BY_ORGANIZATION',
  SEARCH_ACTIVITY_LOGS: 'SEARCH_ACTIVITY_LOGS',
  SEARCH_FIELD_ACTIVITY_LOGS: 'SEARCH_FIELD_ACTIVITY_LOGS',
  DELETE_ACTIVITY_LOG: 'DELETE_ACTIVITY_LOG',
};

export const editorStateToString = (editorState) => {
  const rawContentState = convertToRaw(editorState.getCurrentContent());
  return JSON.stringify(rawContentState);
};

export const stringToEditorState = (str) => {
  const rawContentState = JSON.parse(str);
  const contentState = convertFromRaw(rawContentState);
  return EditorState.createWithContent(contentState);
};

export const ACTIVITY_VIEWS = {
  CHART: 'CHART',
  LIST: 'LIST',
};
